import { render, staticRenderFns } from "./OrderDeliveryListForStoreView.vue?vue&type=template&id=c5024b8e"
import script from "./OrderDeliveryListForStoreView.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryListForStoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports